<div class="relative">
  <ces-button-secondary
    [size]="size()"
    icon="view_column"
    [label]="'common.labels.columns' | transloco"
    (onClick)="menu.toggle($event)" />
  <ces-checkable-menu #menu [popup]="true" [model]="menuItems()" appendTo="body" [baseZIndex]="1000">
    <ng-template #end>
      <div class="measure-column-toggle-actions">
        <button type="button" class="measure-column-toggle-action" (click)="selectAll()">
          {{ 'common.buttons.selectAll' | transloco }}
        </button>
        <button type="button" class="measure-column-toggle-action" (click)="deselectAll()">
          {{ 'common.buttons.deselectAll' | transloco }}
        </button>
      </div>
    </ng-template>
  </ces-checkable-menu>
</div>
